export default {
    namespaced: true,
    state: {
        balance: 1
    },
    actions: {
        add ({commit}, value) {
            commit('add', value || 0)
        },
        remove ({commit}, value) {
            commit('remove', value || 0)
        },
        update () {},
        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        add (state, value) {
            state.balance += value
        },
        remove (state, value) {
            state.balance -= value
        },
        reset (state) {
            state.balance = 1
        }
    }
}
